import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import { ContactFragmentOnContactFeedFragmentDoc } from '../../../crm/contacts/__generated__/contact-fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateContentNarrationMutationVariables = Types.Exact<{
  input: Types.CreateContentNarrationInput;
}>;


export type CreateContentNarrationMutation = { __typename?: 'RootMutationType', createContentNarration?: { __typename?: 'ContentNarrationResult', content?: { __typename?: 'Content', id: string, type: Types.ContentType, groupType: Types.ContentGroupType, body?: any | null, label?: string | null, plainDescription?: string | null, embedLink?: string | null, providerName?: string | null, videoContain?: boolean | null, file?: { __typename?: 'FileUpload', id: string, name?: string | null, size?: number | null, pageCount?: number | null, mimeType?: string | null, fileUrl?: string | null, insertedAt?: any | null } | null, image?: { __typename?: 'StepImageUpload', id: string, name?: string | null, originalUrl?: string | null, fhdUrl?: string | null, alternativeText?: string | null, insertedAt?: any | null } | null, video?: { __typename?: 'VideoUpload', id: string, rawUrl?: string | null, alternativeText?: string | null, transcodedUrl?: string | null, previewUrl?: string | null, streamUrl?: string | null, thumbUrl?: string | null, gifUrl?: string | null, gifWithIconUrl?: string | null, contact?: { __typename?: 'Contact', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, title?: string | null, avatarThumbUrl?: string | null, insertedAt?: any | null, company?: { __typename?: 'Company', id: string, name: string, iconUrl?: string | null, thumbUrl?: string | null } | null } | null } | null, narration?: { __typename?: 'ContentNarration', id: string, title?: string | null, type?: Types.NarrationType | null, video?: { __typename?: 'VideoUpload', id: string, rawUrl?: string | null, transcodedUrl?: string | null, previewUrl?: string | null, streamUrl?: string | null, gifUrl?: string | null, gifWithIconUrl?: string | null } | null } | null } | null, userErrors?: Array<{ __typename?: 'UserError', field: string, message: string } | null> | null } | null };


export const CreateContentNarrationDocument = gql`
    mutation createContentNarration($input: CreateContentNarrationInput!) {
  createContentNarration(input: $input) {
    content {
      id
      type
      groupType
      body
      label
      plainDescription
      embedLink
      providerName
      videoContain
      file {
        id
        name
        size
        pageCount
        mimeType
        fileUrl
        insertedAt
      }
      image {
        id
        name
        originalUrl
        fhdUrl
        alternativeText
        insertedAt
      }
      video {
        id
        rawUrl
        alternativeText
        transcodedUrl
        previewUrl
        streamUrl
        thumbUrl
        gifUrl
        gifWithIconUrl
        contact {
          ...ContactFragmentOnContactFeed
        }
      }
      narration {
        id
        title
        type
        video {
          id
          rawUrl
          transcodedUrl
          previewUrl
          streamUrl
          gifUrl
          gifWithIconUrl
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}
    ${ContactFragmentOnContactFeedFragmentDoc}`;
export type CreateContentNarrationMutationFn = Apollo.MutationFunction<CreateContentNarrationMutation, CreateContentNarrationMutationVariables>;

/**
 * __useCreateContentNarrationMutation__
 *
 * To run a mutation, you first call `useCreateContentNarrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentNarrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentNarrationMutation, { data, loading, error }] = useCreateContentNarrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContentNarrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentNarrationMutation, CreateContentNarrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentNarrationMutation, CreateContentNarrationMutationVariables>(CreateContentNarrationDocument, options);
      }
export type CreateContentNarrationMutationHookResult = ReturnType<typeof useCreateContentNarrationMutation>;
export type CreateContentNarrationMutationResult = Apollo.MutationResult<CreateContentNarrationMutation>;
export type CreateContentNarrationMutationOptions = Apollo.BaseMutationOptions<CreateContentNarrationMutation, CreateContentNarrationMutationVariables>;